import { useState } from 'react';

import NavigationButton from '@atom/components/common/map/mapDrawerContent/NavigationButton';
import NavigationControls from '@atom/components/common/map/mapDrawerContent/NavigationControls';
import { Icon, IconButton, Progress } from '@atom/mui';
import colors from '@atom/styles/colors';
import { UserDetail } from '@atom/types/user';
import userUtilities from '@atom/utilities/userUtilities';

import UserSummaryInfo from './UserSummaryInfo';
import UserSummaryWork from './UserSummaryWork';

import classes from './userSummaryTray.module.css';

const views = [
  {
    value: 'info',
    icon: 'info',
  },
  {
    value: 'work',
    icon: 'work',
  },
];

interface Props {
  user?: UserDetail;
  loading?: boolean;
  workOrders?: any;
  onCancel: () => void;
}

const UserSummaryTray = ({ user, loading, workOrders, onCancel }: Props) => {
  const [activeView, setActiveView] = useState<string>('info');

  const getTrayContentBody = () => {
    switch (activeView) {
      case 'info': {
        return <UserSummaryInfo user={user} />;
      }
      case 'work': {
        return <UserSummaryWork work={workOrders} />;
      }
      default: {
        return <UserSummaryInfo user={user} />;
      }
    }
  };

  const body = getTrayContentBody();

  return (
    <div className={classes.container}>
      {loading ? (
        <div className={classes.spinnerContainer}>
          <Progress />
        </div>
      ) : (
        <div className={classes.trayContainer}>
          <div className={classes.headerContainer}>
            <div className={classes.exitContainer}>
              <IconButton onClick={onCancel}>
                <Icon color={colors.neutral.gray}>close</Icon>
              </IconButton>
            </div>
            <div className={classes.profileContainer}>
              <div className={classes.headerProfileImage}>
                <img className={classes.profileImage} src={user.photoUrl} />
              </div>
              <div className={classes.headerTitleContainer}>
                <div className={classes.headerName}>
                  {userUtilities.getUserFullName(user)}
                </div>
                <div className={classes.headerSubtext}>{user.email}</div>
                <div className={classes.headerSubtext}>{user.role}</div>
              </div>
            </div>
          </div>
          <div className={classes.trayContentContainer}>
            <div className={classes.summaryImageContainer} />
            <NavigationControls
              views={views}
              activeView={activeView}
              setActiveView={setActiveView}
            />
            <div>{body}</div>
          </div>
          <NavigationButton
            label="View Full Detail"
            navigateUrl={`/team/${user?.id}`}
          />
        </div>
      )}
    </div>
  );
};

export default UserSummaryTray;
